export { default } from './DashboardAttributeChart';
